import React from 'react';
import BreadCrumbNav from './BreadCrumbNav';
import Footer from './Footer';
import MainHeader from './MainHeader';
import MobileMenu from './MobileMenu';
import ScrollToTopButton from './ScrollToTopButton';
import SearchPopup from './SearchPopup';
import ServicesContent from './ServicesContent';
import PreLoader from './PreLoader';

const Services = () => {

  return (
    <div className="boxed_wrapper">
        {/* <PreLoader /> */}
        <SearchPopup />
        <MainHeader />
        <MobileMenu />
        <BreadCrumbNav title="Services" />

        <ServicesContent />

        <Footer />
        <ScrollToTopButton />
    </div>
    );
  }
  
  export default Services;